export * from '@primeuix/themes/aura/fileupload';
export { default } from '@primeuix/themes/aura/fileupload';
